import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import Button from 'components/DesignSystem/Button';
import { store } from 'redux/store';
import {
  reset,
  selectMeteorologyAgroCultureIndexLocationTriggerRequest,
} from 'redux/reducers/meteorologyAgroCultureIndexLocationReducer';
import { cultureIndexLocationApi } from 'services/api/Meteorology/Agro/CultureIndex/Location';
import Accordion from 'components/Accordion';
import useParams from 'hooks/Meteorology/Agro/CultureIndex/Location/useParams';
import Culture from './Culture';
import Group from './Group';
import Location from './Location';
import ForecastDate from './ForecastDate';
import Period from './Period';
import PhenologicalStage from './PhenologicalStage';

export default function CultureIndexLocationControlPanel() {
  const params = useParams();
  const triggerRequest = useSelector(
    selectMeteorologyAgroCultureIndexLocationTriggerRequest,
  );

  const clearSelection = useCallback(() => {
    // Limpa os filtros selecionados
    store.dispatch(reset());
    // Limpa o cache dos gráficos do RTK Query
    store.dispatch(cultureIndexLocationApi.util.resetApiState());
  }, []);

  return (
    <div>
      <Accordion>
        <Culture />
        <PhenologicalStage />
        <Group />
        <Location />
        <ForecastDate />
        <Period />
      </Accordion>

      <Button
        className="w-100 mt-5"
        disabled={!params || !triggerRequest}
        onClick={triggerRequest}
      >
        Realizar consulta
      </Button>

      <Button
        className="w-100 mt-1"
        type="secondary"
        onClick={clearSelection}
      >
        Limpar filtros
      </Button>
    </div>
  );
}
